module.exports = __webpack_public_path__ + "img/HeimwehTitle_Background.9c126254.jpg";